import React from 'react';
import { useSelector } from 'react-redux';
import { styled } from 'styled-components';
import { ExternalLink } from '../../Icons/index.js';
import { Button } from '../../index.js';
const LinkToOwnPayment = (props) => {
    const { paymentOption } = props;
    const lang = useSelector((s) => s.lang);
    return (React.createElement("div", null,
        React.createElement("h2", null, paymentOption?.details?.titleToDebtor),
        React.createElement("p", null, paymentOption?.details?.descriptionToDebtor),
        React.createElement(LinkButton, { href: paymentOption?.details?.url, target: "_blank" },
            React.createElement(Button, { size: "small" },
                lang.debtorWeb.goToPayment,
                React.createElement(ExternalLink, { style: { marginLeft: 4 } })))));
};
const LinkButton = styled.a `
  width: 100%;
  display: flex;
  justify-content: center;
  margin-top: 1em;
  text-decoration: none;
`;
export default LinkToOwnPayment;
//# sourceMappingURL=LinkToOwnPayment.js.map